const normalisePermission = (permission) => String(permission).toLowerCase();

const hasPermission = (userPermissions = [], expectedPermission = "") => {
  if (!Array.isArray(userPermissions) || !expectedPermission) return false;

  const expected = normalisePermission(expectedPermission);

  return userPermissions.some(
    (permission) => normalisePermission(permission) === expected,
  );
};

export const isParaplanningAdmin = (userPermissions = []) => {
  return (
    hasPermission(userPermissions, "Administrator") ||
    hasPermission(userPermissions, "Finance Admin")
  );
};

export const isAccountsAdminAccess = (userPermissions = []) => {
  return hasPermission(userPermissions, "Finance Admin");
};

export const isParaplanningViewOnly = (userPermissions = []) => {
  return (
    hasPermission(userPermissions, "Adviser Support") &&
    !hasPermission(userPermissions, "Administrator") &&
      !hasPermission(userPermissions, "Finance Admin")
    //   &&
    // !hasPermission(userPermissions, "Paraplanning")
  );
};

export const ViewAllCasesAccess = (userPermissions = []) => {
  return (
    hasPermission(userPermissions, "Head of Paraplanning") ||
    hasPermission(userPermissions, "Paraplanning Admin") ||
    hasPermission(userPermissions, "Administrator") ||
    hasPermission(userPermissions, "Finance Admin") ||
    hasPermission(userPermissions, "Paraplanning View Only") ||
    isParaplanningViewOnly(userPermissions)
  );
}

export const isParaplanningUser = (userPermissions = []) => {
  return hasPermission(userPermissions, "Paraplanning") && !isParaplanningViewOnly(userPermissions);
};

export const getParaplanningPermissionState = (userPermissions = []) => {
  const isAdmin = isParaplanningAdmin(userPermissions);
  const isAccountsAdmin = isAccountsAdminAccess(userPermissions) || isAdmin;
  const isViewOnly = isParaplanningViewOnly(userPermissions);
  const isParaplanner = isParaplanningUser(userPermissions);
  const canManageCases = !isViewOnly;
    const canManageAllCases = ViewAllCasesAccess(userPermissions);
    
    // console.log("Permission State:", {
    //   isAdmin,
    //     isAccountsAdmin,
    //     isViewOnly,
    //     isParaplanner,
    //     canManageCases,
    //     canManageAllCases,
    // });

  return {
    isAdmin,
    isAccountsAdmin,
    isViewOnly,
    isParaplanner,
    canView: !isViewOnly,
    canManageCases,
    canManageAllCases,
  };
};
